/**
 * Quick Deposit Methods Collection
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var DepositMethodModel = require('portlets/cashier/deposit/deposit.method.model');
    var CashierMethodCollection = require('portlets/cashier/cashier.method.collection');
    var utils = require('utils');

    module.exports = CashierMethodCollection.extend({

        paymentMethod: 'deposit',

        model: DepositMethodModel,

        paymentMethodsOrder: 'byPlayerHistory',

        suggestDepositAmounts: true,

        /**
         * @override
         */
        comparator: _.noop,

        /**
         * @override
         */
        afterParse: function(methods) {
            return methods
                .filter(function(method) {

                    if (!method.account) {
                        return false;
                    }

                    method.account = method.account
                        .filter(function(account) {
                            return account.lastDepositTime && account.view;
                        })
                        .sort(function(acc1, acc2) {
                            var date1 = new Date(acc1.lastDepositTime).getTime();
                            var date2 = new Date(acc2.lastDepositTime).getTime();

                            return utils.predicate.numberPredicate(date1, date2);
                        });

                    return method.account.length;
                })
                .sort(function(method1, method2) {
                    var date1 = new Date(method1.account[0].lastDepositTime).getTime();
                    var date2 = new Date(method2.account[0].lastDepositTime).getTime();

                    return utils.predicate.numberPredicate(date1, date2);
                });
        },

        removeHiddenAccounts: _.noop,

        getMethod: function() {
            return this.first();
        },

        /**
         * Did override for correct methods ordering
         * @override
         */
        extractVisaCheckoutCCToNewMethod: function(methods) {
            return methods;
        }

    });

});
